$(document).ready(function(){
  
  $("#success-msg").hide();
  $("#submission").on("click", function(){
      $("#success-msg").show();
      $("#mc_embed_signup").hide()
  });

  var $form = $('#mc-embedded-subscribe-form');
  if ( $form.length > 0 ) {
      $('form input[type="submit"]').bind('click', function ( event ) {
          if ( event ) event.preventDefault();
          register($form);
      });
  }

  function register($form) {
    $.ajax({
        type: $form.attr('method'),
        url: $form.attr('action'),
        data: $form.serialize(),
        cache       : false,
        dataType    : 'json',
        contentType: "application/json; charset=utf-8",
        error       : function(err) { alert("Could not connect to the registration server. Please try again later."); },
        success     : function(data) {
            if (data.result != "success") {
                // Something went wrong, do something to notify the user. maybe alert(data.msg);
            } else {
                // It worked, carry on...
            }
        }
    });
  }

  $('.responsive').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    arrow:false,
    slidesToScroll: 4,
    adaptiveheight:true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          arrow:false,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrow:false,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          arrow:true,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          infinite: false,
          arrow:true,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

  $('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    asNavFor: '.slider-nav'
  });
  
  $('.slider-nav').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: false,
     arrows: false,
    centerMode: true,
    vertical:true,
    focusOnSelect: true,
     responsive: [
       {
        breakpoint: 750,
        settings: {
           vertical:false,
             arrows: true,
            infinite: false
          }
       }
       ]
  });

  var swap_val = function(val) {
    var input = document.getElementById("mce-EMAIL");
    input.value = val;
  }

  $("#myform").submit(function(e) {
      e.preventDefault();
      document.getElementById('id01').style.display='block';
  });
});
  